import React, { useState, useEffect, useCallback } from "react";
import "../Components/Navbar/Navbar.css"
import axiosConfig from "../Service/axiosConfig"
import Modal from 'react-bootstrap/Modal';
import { NavLink, useSearchParams } from "react-router-dom";
import { PostDP, Navbar, FormParser } from "../Components";
import Masters from "../Components/masters.json"
import { ExploreGrid } from "./exploregrid";
import { useURLParams } from "../Components/UrlUtils/useURLParams"
import { FaTimes } from 'react-icons/fa';
import useDebouncedValue from "../Utils/Debounce";
import CustomTop from "./CustomTop";
import AndroidAppPopup from "../hooks/AndroidAppPopup";
const SearchProducts = () => {
    const { setParam, getParam, getMultiSelectParam, handleMultiSelect } = useURLParams();
    const [searchParams, setSearchParams] = useSearchParams()
    const [Data, setData] = useState([])
    const [loading, setLoading] = useState("")
    const [loading2, setLoading2] = useState("")
    const [query, setQuery] = useState(getParam("search_query") || "")
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1020);
    const [filterShow, setFilterShow] = useState(false)
    const [totalPages, settotalPages] = useState()
    const [initialformData, setinitialFormData] = useState({});
    const [count, setCount] = useState("")
    const [formData, setformData] = useState({
        department: getParam('department') || "",
        project_type: getParam('project_type') || "",
        role: getMultiSelectParam('role'),
        categories: getParam('categories') || "",
        skills: getParam('skills') || "",
        present_state: getParam('present_state') || "",
        present_city: getParam('present_city') || "",
        languages: getMultiSelectParam('languages'),
        gender: getParam('gender') || "",
        from_age: getParam('from_age') || "",
        to_age: getParam('to_age') || "",
        from_height: getParam('from_height') || "",
        to_height: getParam('to_height') || "",
        no_picture: getParam('no_picture') || "",
        is_pro: getParam('is_pro') || "",
        ordering: getParam('ordering') || ""
    })
    const generateQueryString = (data) => {
        const queryStringParts = Object.entries(data)
            .filter(([_, value]) => value && (Array.isArray(value) ? value.length > 0 : true)) // Filter out empty values
            .map(([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(Array.isArray(value) ? value.join(',') : value)}`
            );
        return queryStringParts.join('&');
    };
    let page = 1;
    const debouncedSearchTerm = useDebouncedValue(query, 500);
    const handleInputChangeDebounced = (event) => {
        const newQuery = event.target.value;
        setQuery(newQuery);
        const updatedData = { ...formData, search_query: newQuery };
        setSearchParams(generateQueryString(updatedData));
    };
    const formSubmit = (Data) => {
        setFilterShow(false);
        const updatedData = { ...Data, search_query: query };
        setformData(Data);
        setSearchParams(generateQueryString(updatedData));
    };
    const HandleSort = (e) => {
        const { name, value } = e.target;
        const updatedData = { ...formData, search_query: query, [name]: value };
        const dataStore = { ...formData, [name]: value }
        setformData(dataStore);
        setSearchParams(generateQueryString(updatedData));
    };
    const handleResize = () => {
        setIsMobile(window.innerWidth < 1020);
    };
    const generateArrayQueryString = (key, array) => {
        return array && array.length > 0
            ? array.map(item => `${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`).join('&')
            : '';
    };
    const constructApiParams = (page) => {
        const existingParams = window.location.search; // Get existing URL parameters
        const additionalParams = `page_size=20&page=${page}`;

        return existingParams ? `${existingParams}&${additionalParams}` : `?${additionalParams}`;
    };
    const GetData = async () => {
        const roleQueryString = generateArrayQueryString('role', formData.role);
        const languagesQueryString = generateArrayQueryString('languages', formData.languages);
        const apiParams = constructApiParams(page);
        let url = `/accounts/user-profiles/${apiParams}${roleQueryString ? `&${roleQueryString}` : ''}${languagesQueryString ? `&${languagesQueryString}` : ''}`
        try {
            await axiosConfig.get(url)
                .then(response => {
                    setCount(response.data.count)
                    settotalPages(Math.ceil(response.data.count / 20));
                    setData(response.data.results);
                    setLoading(false);
                })
                .catch(error => {
                    console.log(error.response.data.error);
                });
        }
        catch (error) {
            console.log(error)
        }
    }
    const handleInfiniteScroll = async () => {
        try {
            if (
                window.innerHeight + document.documentElement.scrollTop + 201 >=
                document.documentElement.scrollHeight
            ) {
                if (page <= totalPages && !loading2) {
                    setLoading2(true);
                    page = page + 1;
                    const roleQueryString = generateArrayQueryString('role', formData.role);
                    const languagesQueryString = generateArrayQueryString('languages', formData.languages);
                    const apiParams = constructApiParams(page);
                    const url = `/accounts/user-profiles/${apiParams}${roleQueryString ? `&${roleQueryString}` : ''}${languagesQueryString ? `&${languagesQueryString}` : ''}`;
                    const resp = await axiosConfig.get(url);
                    setData((Data) => [...Data, ...resp.data.results]);
                    setLoading2(false);
                }
            }
        } catch (error) {
            console.log(error);
            setLoading2(false);
        }
    };
    const loadFormDataFromURL = () => {
        setLoading(true);
        setinitialFormData(formData);
        setLoading(false);
    };
    useEffect(() => {
        GetData();
        loadFormDataFromURL();
    }, [formData, debouncedSearchTerm])
    useEffect(() => {
        window.addEventListener('scroll', handleInfiniteScroll);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('scroll', handleInfiniteScroll);
            window.removeEventListener("resize", handleResize);
        }
    }, [totalPages])
    const handleRemove = (key, itemToRemove = null) => {
        setformData((prevFormData) => {
            const newFormData = { ...prevFormData };
            if (Array.isArray(newFormData[key])) {
                newFormData[key] = newFormData[key].filter((item) => item !== itemToRemove);
            } else if (key === "query") {
                setQuery("")
            } else {
                newFormData[key] = '';
            }
            formSubmit(newFormData)
            return newFormData;
        });
    };

    console.log("window.location.search",window.location.search)

    return (
        <>
            <CustomTop query={query} handleInputChangeDebounced={handleInputChangeDebounced} />
            <div className="search-screen-container search-page">
                <Navbar />
                <AndroidAppPopup targetUrl={window.location.href} />
                  <div className="content-area">
                    <div className="container-position filter_button_down">
                        <div class="inlineContainer">
                            <div className="sort-content">
                                <select className="Selectbar" id="sortby" name="ordering" onChange={HandleSort} value={formData.ordering}>
                                    <option value="">Sort By</option>
                                    <option value="id">Fisrt to Last</option>
                                    <option value="-id">Last to First</option>
                                    <option value="user__first_name">Name (A to Z)</option>
                                    <option value="-user__first_name">Name (Z to A)</option>
                                </select>
                            </div>
                            <div class="inlineHeader">
                                <div className="view-btn filter-btn" onClick={() => setFilterShow(true)}><img src={require("./images/filtersearch.png")} alt="" />Filters ({count})</div>
                            </div>
                            <div className="inlinBpContainer">
                                {Object.entries(formData).map(([key, value], index) =>
                                    Array.isArray(value) && value.length > 0 ? (
                                        value.map((item, itemIndex) => (
                                            <button key={`${index}-${itemIndex}`} className="btn btn-shortlist shortlist-icon">
                                                <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: 0 }}>
                                                    <b>{`${key}: ${item}`}</b>
                                                    <span style={{ marginLeft: '8px', cursor: 'pointer' }}>
                                                        <FaTimes size={18} onClick={() => handleRemove(key, item)} />
                                                    </span>
                                                </p>
                                            </button>
                                        ))
                                    ) : !Array.isArray(value) && value ? (
                                        <button key={index} className="btn btn-shortlist shortlist-icon">
                                            <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: 0 }}>
                                                <b>{`${key}: ${value}`}</b>
                                                <span style={{ marginLeft: '8px', cursor: 'pointer' }}>
                                                    <FaTimes size={18} onClick={() => handleRemove(key)} />
                                                </span>
                                            </p>
                                        </button>
                                    ) : null
                                )}
                            </div>
                        </div>
                    </div>
                    <ExploreGrid Data={Data} loading={loading} loading2={loading2} />
                </div>
            </div>
            <Modal
                show={filterShow}
                onHide={() => setFilterShow(false)}
                aria-labelledby="example-modal-sizes-title-sm"
                className="mobile-filter-pop modal-responsive"
            >
                <Modal.Body className="">
                    <button variant="primary" className="btn btn-default close-btn" onClick={() => setFilterShow(false)}>
                        X
                    </button>
                    <FormParser modelObject={Masters.FilterForm} formData={initialformData} formSubmit={formSubmit} />
                </Modal.Body>
            </Modal>
        </>
    )
}
export { SearchProducts };